// extracted by mini-css-extract-plugin
export default {"table":"table-FbllG","arrow":"arrow-PDfvF","arrowInactive":"arrowInactive-JuQCX","columnHeader":"columnHeader-OSda4","arrowSorted":"arrowSorted-MaVz_","arrowUp":"arrowUp-SSA7U"};